import State from 'interfaces/state/TeamState';

import * as Const from '../constants';

const initState: State = {
  list: [],
  isLoading: false,
  isError: false,
};

export default function team(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.TEAM_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.TEAM_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: true,
      };

    case Const.TEAM_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.TEAM_LIST:
      return {
        ...state,
        list: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.TEAM_DELETE:
      return {
        ...state,
        list: [...state.list].filter(team => team.id !== action.id),
        isLoading: false,
        isError: false,
      };

    case Const.TEAM_CREATE:
      return {
        ...state,
        list: [action.payload, ...state.list],
        isLoading: false,
        isError: false,
      };

    default:
      return state;
  }
}
